// this function exists as a TS no-op to make the keys appear verbatim at least once in code for searchability
import { type BoothTab, BoothTabSection } from './BoothEnums.ts';

export const tabI18nKey = (
  tab: BoothTab,
):
  | 'dealers:tab.all'
  | 'dealers:tab.bookmarks'
  | 'dealers:tab.avatar_bases'
  | 'dealers:tab.avatar_services_and_assets'
  | 'dealers:tab.2d_illustration_and_other' => `dealers:tab.${tab}`;

export const sectionI18nKey = (
  section: BoothTabSection,
):
  | 'dealers:tab.section.lower'
  | 'dealers:tab.section.middle'
  | 'dealers:tab.section.upper'
  | null => (section === BoothTabSection.ALL ? null : `dealers:tab.section.${section}`);
